import { MoveBilletsModal } from "../modals/MoveBilletsModal";
import { MODAL_TYPES, ModalType } from "../../constants";
import { useProfiles } from "../../hooks";

interface MoveBilletsModalWrapperProps {
  currentModal: ModalType;
  isModalOpen: (modalType: ModalType) => boolean;
  sourceLocationId: number | null;
  destinationLocationId: number | null;
  storedCraneId: number | null;
  onClose: () => void;
  refreshInterval?: number;
}

export const MoveBilletsModalWrapper = ({
  currentModal,
  isModalOpen,
  sourceLocationId,
  destinationLocationId,
  storedCraneId,
  onClose,
  refreshInterval,
}: MoveBilletsModalWrapperProps) => {
  const { isSupervisor, isOperator } = useProfiles();

  // Early returns for permissions and modal state
  if ((!isSupervisor && !isOperator) || !isModalOpen(MODAL_TYPES.MOVE))
    return null;

  // Ensure all required props are available before rendering
  if (!sourceLocationId || !destinationLocationId || !storedCraneId)
    return null;

  return (
    <MoveBilletsModal
      show={currentModal === MODAL_TYPES.MOVE}
      onHide={onClose}
      sourceLocationId={sourceLocationId}
      destinationLocationId={destinationLocationId}
      selectedCraneId={storedCraneId}
      refreshInterval={refreshInterval}
      canBypassBilletLimit={isSupervisor}
    />
  );
};
